import { AlertDescription, AlertTitle, useToast as useChakraToast, UseToastOptions } from '@chakra-ui/react';
import { DateTime } from 'luxon';
import Box from '../Box/Box';
import Notification, { ActionProps, NotificationAction, NotificationProps } from '../Notification/Notification';
import { DataAttributes } from '../../types/bitkit';

export interface ToastOptions extends DataAttributes {
  title?: string;
  description: React.ReactNode;
  status: NotificationProps['status'];
  action?: ActionProps;
  duration?: UseToastOptions['duration'];
  position?: UseToastOptions['position'];
  isClosable?: boolean;
  showTimestamp?: boolean;
}

const useToast = () => {
  const toast = useChakraToast();
  return ({
    action,
    description,
    duration,
    isClosable,
    position,
    showTimestamp,
    status,
    title,
    ...rest
  }: ToastOptions) => {
    let timestamp: string | undefined;
    if (showTimestamp) {
      timestamp = DateTime.now().toFormat('hh:mm:ssa');
    }
    toast({
      duration,
      isClosable,
      position: position || 'top-right',
      render: ({ onClose }) => (
        <Notification
          boxShadow="large"
          maxW="437px"
          onClose={isClosable ? onClose : undefined}
          status={status || 'info'}
          {...rest}
        >
          <Box display="flex" flexDirection="column">
            {title && <AlertTitle>{title}</AlertTitle>}
            {description && <AlertDescription>{description}</AlertDescription>}
            {!action && timestamp && <AlertDescription marginTop="8">{timestamp}</AlertDescription>}
            {action && <NotificationAction alignSelf="start" marginBottom="4" marginTop="8" {...action} />}
          </Box>
        </Notification>
      ),
    });
  };
};

export default useToast;
